import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientUserActivityReportService {

  constructor(private http: HttpClient) { }

  ur1 = environment.serverAPI9 + "/api/clientUserActivityReport";

  ur2 = environment.serverAPI9 + "/api/userAccountActivityReport/account";

  searchClientUserActivityReport(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery?: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      "additionalQuery": additionalQuery
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur1}/condition/${queryParams}`, requestBody);
  }


  searchUserAccountActivityReport(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery?: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      "additionalQuery": additionalQuery
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur2}/condition/${queryParams}`, requestBody);
  }

}
